var s = /* @__PURE__ */ ((e) => (e.AccessToken = "access_token", e.ChainType = "chain_type", e.FakeRefreshToken = "fake_refresh_token", e.Provider = "provider", e.RefreshToken = "refresh_token", e.UserId = "user_id", e.SsoState = "sso_state", e))(s || {});
export {
  s as LocalStorageKey
};
//# sourceMappingURL=storage.js.map
